// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2Uiyb","title":"Images90_title__5g8MO","images":"Images90_images__198KL"};